import { render, staticRenderFns } from "./MemberTable.vue?vue&type=template&id=0fce0fa2"
import script from "./MemberTable.vue?vue&type=script&lang=js"
export * from "./MemberTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/admin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0fce0fa2')) {
      api.createRecord('0fce0fa2', component.options)
    } else {
      api.reload('0fce0fa2', component.options)
    }
    module.hot.accept("./MemberTable.vue?vue&type=template&id=0fce0fa2", function () {
      api.rerender('0fce0fa2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Organisation/MemberTable.vue"
export default component.exports